import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./PresetTest.module.scss";
import Axios from "../../../../_services/caller.service";
import {
  AiOutlineClose,
  AiOutlineExclamationCircle,
  AiOutlineInfoCircle,
} from "react-icons/ai";
import { MdDeleteOutline } from "react-icons/md";
import download from "downloadjs";
import Button from "../../../UiComponents/Button";
import DropZone from "../../../UiComponents/dropZone/DropZone";

import Loader from "../../../UiComponents/loader/Loader";
import Success from "../../../UiComponents/sucess/Success";
import ModalConfirmNewPreset from "../modal/ModalConfirmNewPreset";

import { arrayMoveImmutable } from "array-move";

import SortableTest from "../sortable/SortablePreset";
import { PermissionGate } from "../../../superAdmin/managePermissions/PermissionGate";

const PresetTest = ({ userId, setOverlay }) => {
  const [presetTest, setPresetTest] = useState([]);
  const [displayDescription, setDisplayDescription] = useState(null);

  const [maj, setMaj] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSucess] = useState(false);

  // IMPORT EXPORT
  const [selectedFile, setSelectedFile] = useState();
  const [modalConfirmNewPreset, setModalConfirmNewPreset] = useState(false);

  const [isNotGoodImportFileType, setIsNotGoodImportFileType] = useState(false);

  useEffect(() => {
    if (userId !== "") {
      Axios.get(`/presetTest/${userId}`)

        .then(function async(response) {
          setPresetTest(response.data.data);
          setIsNotGoodImportFileType(false);
        })
        .catch(function (error) {
          // console.log(error);
        });
    }
  }, [userId, maj]);

  //EXPORT
  const exportSelectedCards = () => {
    const dataStr = JSON.stringify(presetTest);
    const filename = `Presets Test id-${userId}.txt`;
    const filetype = "text/plain";

    // Download the file
    download(dataStr, filename, filetype);
  };

  // IMPORT
  const importPresetTest = () => {
    const reader = new FileReader();

    reader.onload = async (e) => {
      // The file's text will be printed here
      const text = e.target.result;

      const data = JSON.parse(text);

      //verifie si c'est le bon type de preset
      const hasPreset = data[0].preset.includes("<Preset>");
      if (!hasPreset) {
        setIsNotGoodImportFileType(true);
        return;
      }

      setPresetTest([...presetTest, ...data]);
    };
    reader.readAsText(selectedFile, "ISO-8859-1");
  };

  const fileChangedHandler = (file) => {
    setSelectedFile(file);
  };

  useEffect(() => {
    if (selectedFile) {
      importPresetTest();
    }
  }, [selectedFile]);

  //ACTIVE MODAL CONFIRM

  const activeModalConfirm = (params) => {
    setOverlay(true);
    setModalConfirmNewPreset(true);
  };

  //REGISTER NEW PRESET
  const registerNewPreset = () => {
    Axios.put(`/updatePresetTest/${userId}`, {
      data: presetTest,
    })

      .then((response) => {
        setLoading(false);
        setSucess(true);
        setTimeout(() => {
          setSucess(false);
          setModalConfirmNewPreset(false);
          setOverlay(false);
        }, 1500);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <>
      <div>
        <h2 className={styles.title}>Preset de Test</h2>
        <div className={styles.containerBtnExport}>
          <PermissionGate actionKey="presetTest.export">
            <Button
              onPress={exportSelectedCards}
              styles={"btnExport"}
              text={"Exporter la selection"}
            />
          </PermissionGate>

          <div className={styles.containerImport}>
            <div className={styles.containerInputImport}>
              <label className={styles.uploadLabel}>
                Sélectionner un fichier
                <PermissionGate actionKey="presetTest.import">
                  <input
                    type="file"
                    onChange={(e) => fileChangedHandler(e.target.files[0])}
                    className={styles.hiddenInput}
                  />
                </PermissionGate>
              </label>
              <Button
                onPress={() => {
                  setMaj(!maj);
                }}
                styles={"btnPrimary"}
                text={"Refresh"}
              />
            </div>
          </div>
        </div>

        {isNotGoodImportFileType && (
          <div className={styles.emptySelectedCard}>
            {" "}
            <AiOutlineExclamationCircle
              style={{ color: "orange", fontSize: "20px" }}
            />
            <span>Vous importez pas le bon type de Preset</span>
            <AiOutlineClose
              onClick={() => setIsNotGoodImportFileType(false)}
              style={{ cursor: "pointer", fontSize: "20px" }}
            />
          </div>
        )}
        <SortableTest
          presetType={presetTest}
          setPresetType={setPresetTest}
          displayDescription={displayDescription}
          setDisplayDescription={setDisplayDescription}
        />

        <div className={styles.btnUpdate}>
             <PermissionGate actionKey="presetTest.update">
          <Button
            onPress={activeModalConfirm}
            styles={"btnValidation"}
            text={"Enregistrer les nouvelles valeurs"}
          /></PermissionGate>
        </div>
        {modalConfirmNewPreset && (
          <ModalConfirmNewPreset
            setOverlay={setOverlay}
            setModalConfirmRegisterNewPreset={setModalConfirmNewPreset}
            registerNewValue={registerNewPreset}
            success={success}
          />
        )}
        {loading && <Loader />}
      </div>
    </>
  );
};

export default PresetTest;

// // POUR DRAG EN DROP
// const onDragEnd = (result) => {
//   if (!result.destination) {
//     return;
//   }
//   const items = Array.from(presetTest);
//   const [reorderedItem] = items.splice(result.source.index, 1);
//   items.splice(result.destination.index, 0, reorderedItem);

//   // Mettre à jour l'état avec les items réorganisés
//   setPresetTest(items);
// };
